import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { createMetaManager } from "vue-meta";
import i18n from "./i18n"; // 引入 i18n
import { inject } from "@vercel/analytics";

inject(); // 初始化 Vercel Analytics

const app = createApp(App);
app.use(router);
app.use(store);
app.use(createMetaManager());
app.use(i18n); // 使用 i18n
app.mount("#app");
